module.exports = __webpack_public_path__ + "img/hero-dark.a3beb481.jpg";